export enum ShadowType {
  Inset = 'inset'
}
